import devConfig from './app.dev.config';
import prodConfig from './app.prd.config';
import qasConfig from './app.qas.config';
import localConfig from './app.local.config';
import dmzConfig from './app.dmz.config';
import prddmzConfig from './app.prddmz.config';
const getConfiguration = (environment) => {
  switch (environment) {
    case 'local':
      return localConfig;
    case 'dev':
      return devConfig;
    case 'qas':
      return qasConfig;
    case 'prd':
      return prodConfig;
    case 'dmz':
      return dmzConfig;
    case 'prddmz':
      return prddmzConfig;
    default:
      return localConfig;
  }
};
/* global process */
const AppConfig = getConfiguration(process.env.REACT_APP_ENV);
export default AppConfig;
